/**
 * Bridges intent (a menu click, a drag) to the outcome event the mutation
 * hook fires, without threading props through every call chain.
 */

export interface Intent {
  action: string;
  surface: string;
  objectKind?: string;
}

interface NotedIntent extends Intent {
  at: number;
}

let lastIntent: NotedIntent | null = null;

export function noteIntent(intent: Intent): void {
  lastIntent = { ...intent, at: Date.now() };
}

export function consumeIntent(maxAgeMs = 5000): Record<string, string> {
  const intent = lastIntent;
  lastIntent = null;
  if (!intent || Date.now() - intent.at > maxAgeMs) return {};
  return {
    last_intent_action: intent.action,
    last_intent_surface: intent.surface,
  };
}

/** vitest only. */
export function clearIntentForTest(): void {
  lastIntent = null;
}
